import { createReducer } from 'src/helpers/reducer';
import { ICardsState, ILoadDataSuccessPayload } from './types';
import actionsTypes from './actionTypes';

const initState: ICardsState = {
  cards: undefined,
  isLoading: false,
  total: 0,
};

function onLoadCardsRequest(state: ICardsState): ICardsState {
  return {
    ...state,
    isLoading: true,
  };
}

function onLoadCardsSuccess(state: ICardsState, { payload }: { payload: ILoadDataSuccessPayload }): ICardsState {
  const { cards, total, filteredTotal } = payload;

  return {
    ...state,
    cards,
    total,
    filteredTotal,
    isLoading: false,
  };
}

function onLoadCardsError(state: ICardsState) {
  return {
    ...state,
    isLoading: false,
  };
}

export default createReducer(initState, {
  [actionsTypes.LOAD_CARDS_REQUEST]: onLoadCardsRequest,
  [actionsTypes.LOAD_CARDS_SUCCESS]: onLoadCardsSuccess,
  [actionsTypes.LOAD_CARDS_ERROR]: onLoadCardsError,
});
